interface SkeletonProps {
	width?: number | string;
	height?: number | string;
	circle?: boolean;
	className?: string;
}

export default function Skeleton({ width, height, circle, className = "" }: SkeletonProps) {
	const style: React.CSSProperties = {};

	if (width !== undefined) {
		style.width = typeof width === "number" ? `${width}px` : width;
	}

	if (height !== undefined) {
		style.height = typeof height === "number" ? `${height}px` : height;
	}

	if (circle && width !== undefined && height === undefined) {
		style.height = style.width;
	}

	return <div style={style} className={`bg-gray-200 animate-pulse shrink-0 ${circle ? "rounded-full" : "rounded"} ${className}`} />;
}
